import { useCallback } from 'react';
import downloadCsv from '@dyl/utils/downloadAssetCsv';

/** @type {import('@dyl/utils/downloadCsv').CsvColumn[]} */
const Columns = [
    { label: 'Task ID', key: 'task_id_name' },
    { label: 'Component ID', key: 'test_names' },
    { label: 'Skill', key: 'skill_id' },
    { label: 'Task Type', key: 'task_type_id' },
    { label: 'Last Modified', key: 'updated_at' },
    { label: 'Anchor', key: 'anchor' },
];

export default function useTasksDownload() {
    return useCallback(
        function downloadTasksCsv(tasks) {

            const fileName = `Tasks_${new Date().toDateString()}.csv`;

            downloadCsv(fileName, Columns, tasks);
        }, []
    );
}